import { ButtonLink } from "@/components/Buttons";
import QuestionnaireForm from "@/components/Form/QuestionnaireForm";
import ProcessInformation from "@/components/ProcessInformation";
import { useFormQuestionsQuery, useModal, useNotification } from "@/hooks";
import config from "@/lib/config";
import {
  COURSE_TRIAL_DURATION_UNIT,
  PAYMENT_METHOD_NAMES,
} from "@/lib/constants";
import dayjs from "@/lib/day";
import formatPrice from "@/lib/formatPrice";
import routes from "@/lib/routes";
import styles from "@/styles/Payment.module.scss";
import processStyles from "@/styles/Process.module.scss";
import Link from "next/link";
import { useEffect, useMemo } from "react";

export default function SubscriptionFormStep3({
  subscriptionData,
  paymentMethodId,
  subscribeData,
  isSignUp,
}) {
  const { course, subscriptionStatus /*broadcastDiscount*/ } = subscriptionData;
  const price = formatPrice(course?.price || 0);
  const trialFlag = subscriptionStatus.is_trial_enabled;
  // const broadcastDiscountFlag = useMemo(() => {
  //   // コースに適用されたキャンペーンのbroadcastDiscountフラグを参照して判定する
  //   const isBroadcastCampaign =
  //     course?.active_pricing?.campaign?.broadcastDiscount;
  //   return isBroadcastCampaign && broadcastDiscount?.result;
  // }, [course, broadcastDiscount]);
  // const broadcastDiscountPrice = formatPrice(course?.discount_price);
  // 契約API（subscription/subscribe）のsubscribeレスポンスのコースから価格取得
  let priceFromSubscribeData =
    subscribeData?.subscribe?.course?.active_pricing?.payment_amount;
  let priceFromSubscribeOrder = subscribeData?.subscribe?.orderPrice;
  if (isNaN(parseInt(priceFromSubscribeData))) {
    // 価格が不正な場合は空文字を表示する
    priceFromSubscribeData = "";
  }
  if (isNaN(parseInt(priceFromSubscribeOrder))) {
    // 価格が不正な場合は空文字を表示する
    priceFromSubscribeOrder = "";
  }
  const { initialTransactionAt, trialStartAt, trialEndAt } =
    subscribeData?.subscribe;
  const trialTerm = useMemo(() => {
    if (trialFlag) {
      const s = dayjs(new Date(trialStartAt));
      const e = dayjs(new Date(trialEndAt));
      const { label, unit } =
        COURSE_TRIAL_DURATION_UNIT[course.trial_term_unit];
      return `${e.diff(s, unit)}${label}`;
    }
  }, [trialFlag, trialStartAt, trialEndAt]);

  const trialTermText = useMemo(() => {
    if (trialTerm) {
      return course?.trialCampaignFlag
        ? `${trialTerm}無料キャンペーン`
        : `${trialTerm}無料トライアル`;
    }
  }, [course, trialTerm]);

  // アンケート表示
  const questionId = config.signUpQuestionnaireId;
  const { showModal, hideModal } = useModal();
  const { showNotification } = useNotification();

  const { data: questionnaireData } = useFormQuestionsQuery({
    variables: { id: questionId },
  });

  //モーダル表示部分
  useEffect(() => {
    if (isSignUp && questionnaireData?.formQuestions?.data) {
      // true:スキップさせる
      // false:スキップさせない
      let isSkipAble = questionnaireData.formQuestions.values?.skipable;
      if (typeof isSkipAble !== "boolean") {
        isSkipAble = true;
      }
      showModal(
        <QuestionnaireForm
          hideModal={hideModal}
          showNotification={showNotification}
          questionId={questionId}
          isSkipAble={isSkipAble}
        />,
        {
          style: "questionaireModal",
          closeButton: isSkipAble,
          outerAreaClose: isSkipAble,
        }
      );
    }
  }, [showModal, hideModal, questionId, questionnaireData, isSignUp]);

  return (
    <ProcessInformation complete header="購入が完了しました">
      {trialFlag && (
        <div>
          {trialTerm}の無料
          {course.trialCampaignFlag && "キャンペーン"}期間をお楽しみください
        </div>
      )}
      <div className={`${styles.container} ${styles.center}`}>
        <div className={`${styles.section} ${styles.nopadding}`}>
          <div className={styles.sectionLeft}>
            <img src={course.thumbnailUrl} />
          </div>
          <div className={styles.sectionRight}>
            <h4 className={styles.title}>{course.name}</h4>
            {/* 通常価格 */}
            {!trialFlag /*&& !broadcastDiscountFlag*/ && (
              <div className={`${styles.info} ${styles.price}`}>
                <div className={styles.left}>金額</div>
                <div className={styles.right}>
                  <span className={styles.priceAmount}>
                    {priceFromSubscribeOrder}円
                  </span>
                  （税込）／月
                </div>
              </div>
            )}
            {/* トライアル価格 */}
            {trialFlag /*&& !broadcastDiscountFlag*/ && (
              <div
                className={`${styles.info} ${styles.price} ${styles.trialPrice}`}
              >
                <div className={styles.right}>
                  <div className={styles.labelArea}>
                    <span className={styles.bold}>{trialTermText}</span>
                    <span className={styles.period}>{`${trialEndAt}まで`}</span>
                  </div>
                  <div className={styles.precautions}>
                    {`※${course.trialText}終了時に月額${priceFromSubscribeData}円（税込）`}
                  </div>
                </div>
              </div>
            )}
            {/* 放送契約者割引価格 */}
            {/*broadcastDiscountFlag && !trialFlag && (
              <>
                <div className={`${styles.info} ${styles.price}`}>
                  <div className={styles.left}>割引金額</div>
                  <div className={styles.right}>
                    <span className={styles.priceAmount}>
                      {priceFromSubscribeOrder}円
                    </span>
                    （税込）／月
                    <br />
                  </div>
                </div>
              </>
            )*/}
            {/* トライアルかつ放送契約者割引価格 */}
            {/*broadcastDiscountFlag && trialFlag && (
              <div
                className={`${styles.info} ${styles.price} ${styles.trialPrice}`}
              >
                <div className={styles.right}>
                  <div className={styles.labelArea}>
                    <span className={styles.bold}>{trialTermText}</span>
                    <span className={styles.period}>{`${trialEndAt}まで`}</span>
                  </div>
                  <div className={styles.precautions}>
                    {`※${course.trialText}期間後は月額${priceFromSubscribeData}円（税込）`}
                    <br />
                    <Link href={routes.campaignWithBroadcast}>
                      対象の放送商品
                    </Link>
                    {`をご契約中の方は${course.trialText}終了時に月額${broadcastDiscountPrice}円(税込)`}
                  </div>
                </div>
              </div>
            )*/}
            <div className={`${styles.info} ${styles.paymentMethodId}`}>
              <div className={styles.left}>支払方法</div>
              <div className={styles.right}>
                {PAYMENT_METHOD_NAMES[paymentMethodId]}
              </div>
            </div>
            <div className={styles.info}>
              <div className={styles.left}>初回決済日</div>
              <div className={styles.right}>{initialTransactionAt}</div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.attentionNote}>
        <p>
          引き続きSPOOXをお楽しみください
          <br />
          本商品は自動更新となります。ご解約の際はアカウントのご利用状況からお手続きください
        </p>
      </div>
      <div className={processStyles.btnArea}>
        <ButtonLink
          href={routes.channelDetail(course?.channel?.id)}
          fillColor
          large
          fontFixed
        >
          さっそく視聴可能作品をチェックする
        </ButtonLink>
      </div>
      {/*broadcastDiscountFlag && !trialFlag && (
        <>
          <br />
          ※割引条件は
          <span className={styles.discountLink}>
            <Link href={routes.campaignWithBroadcast}>こちら</Link>
          </span>
          をご覧ください。
        </>
      )*/}
    </ProcessInformation>
  );
}
